import * as React from "react";
import { Outlet, useLocation } from "react-router-dom";

import { useSiteSettings } from "@/features/site/site.api";
import { useLocale } from "@/features/i18n/locale-provider";
import { WhatsAppFab } from "@/components/whatsapp-fab";
import { SiteFooter } from "./site-footer";
import { SiteHeader } from "./site-header";

export function SiteLayout() {
  const { data: settings } = useSiteSettings();
  const { t } = useLocale();
  const { pathname } = useLocation();

  // Each route starts at the top; smooth-scroll is disabled under reduced motion.
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" as ScrollBehavior });
  }, [pathname]);

  React.useEffect(() => {
    if (settings?.metaTitle) document.title = settings.metaTitle;
  }, [settings?.metaTitle]);

  return (
    <div className="flex min-h-screen flex-col bg-bg">
      <a
        href="#main"
        className="sr-only rounded-[var(--radius-control)] bg-ink px-4 py-3 text-on-dark focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50"
      >
        {t("nav.skip")}
      </a>

      <SiteHeader brandName={settings?.brandName ?? "D'Teba Villa"} />

      <main id="main" className="flex-1">
        <Outlet />
      </main>

      <SiteFooter settings={settings} />
      {settings?.whatsappNumber && <WhatsAppFab number={settings.whatsappNumber} />}
    </div>
  );
}
